import { tuple } from '../../shared/typescript/tuple.js';

const locales = tuple("da-DK", "de-AT", "de-CH", "de-DE", "en-AU", "en-CA", "en-GB", "en-IE", "en-NZ", "en-US", "es-ES", "fi-FI", "fr-BE", "fr-FR", "it-IT", "ja-JP", "nb-NO", "nl-BE", "nl-NL", "pl-PL", "pt-BR", "pt-PT", "ru-RU", "sv-SE");

export { locales };
//# sourceMappingURL=ConstellationProvider.types.js.map
